import moment from 'moment';

// this is taken from dayzed to mimic their selectable validation with min max date.

export function isSelectable(minDate, maxDate, date) {
  const a = moment(minDate);
  const b = moment(maxDate);
  const d = moment(date);

  if ((minDate && d.isBefore(a)) || (maxDate && b.isBefore(date))) {
    return false;
  }

  return true;
}

export function getSumOrZero(a, b) {
  const sum = a + b;
  return sum > 0 ? sum : 0;
}

export function getIsUnselectableByTypeAndMinMax(data, minDate, maxDate) {
  const dateToManipulate = new Date();
  if (data.type === 'months') {
    dateToManipulate.setMonth(data.key);
    dateToManipulate.setFullYear(data.selectedYear);
  } else if (data.type === 'years') {
    dateToManipulate.setFullYear(data.value);
  }
  const isBeforeMin =
    !!minDate && moment(dateToManipulate).isBefore(moment(minDate).startOf(data.type));
  const isAfterMax =
    !!maxDate && moment(dateToManipulate).isAfter(moment(maxDate).endOf(data.type));

  return isBeforeMin || isAfterMax;
}
